import cx from 'classnames';

import { Wysiwyg } from 'components/shared/Wysiwyg';
import { WysiwygData } from 'components/shared/Wysiwyg/Wysiwyg.types';
import i18n from 'i18n';
import { currencyFormat } from 'utils/form/format';

import useCosts from './functions';
import s from './index.module.css';
import { TCostsContent, TMainCostInfoProps, TTotalCostInfoProps } from './types';

// @ts-ignore
export default function Costs(props) {
  const {
    type,
    guestCount,
    value,
    currency,
    costsCurrency,
    roomingConfigurationEnabled,
    roomingConfigurationWysiwyg,
    accommodationType,
    notesEnabled,
    notesWysiwyg,
    includesWysiwyg,
    notIncludesWysiwyg,
    handleClick,
    determined,
    topTextEnabled,
  } = useCosts(props);
  const mainCostsInfoProps = {
    type,
    guestCount,
    value,
    currency,
    costsCurrency,
    roomingConfigurationEnabled,
    roomingConfigurationWysiwyg,
    accommodationType,
    determined,
    topTextEnabled,
  };

  return (
    <CostsContent
      mainCostsInfoProps={mainCostsInfoProps}
      handleClick={handleClick}
      notesEnabled={notesEnabled}
      notesWysiwyg={notesWysiwyg}
      includesWysiwyg={includesWysiwyg}
      notIncludesWysiwyg={notIncludesWysiwyg}
    />
  );
}

export function CostsContent({
  mainCostsInfoProps,
  handleClick,
  notesEnabled,
  notesWysiwyg,
  includesWysiwyg,
  notIncludesWysiwyg,
}: TCostsContent) {
  return (
    <div className={cx(s.wrapper, 'custom-costs-wrapper')} onClick={handleClick}>
      <MainCostsInfo {...mainCostsInfoProps} />
      {notesEnabled && <CostsItem title={`${i18n.t('proposal_content.costs.notes')}:`} desc={notesWysiwyg.data} />}

      {includesWysiwyg?.data?.text && (
        <CostsItem title={`${i18n.t('proposal_content.costs.includes')}:`} desc={includesWysiwyg.data} />
      )}

      {notIncludesWysiwyg?.data?.text && (
        <CostsItem title={`${i18n.t('proposal_content.costs.excludes')}:`} desc={notIncludesWysiwyg.data} />
      )}
    </div>
  );
}

export function MainCostsInfo({
  type,
  guestCount,
  accommodationType,
  determined,
  currency,
  costsCurrency,
  value,
  roomingConfigurationEnabled,
  roomingConfigurationWysiwyg,
  topTextEnabled = true,
}: TMainCostInfoProps) {
  return (
    <div className={cx(s.item, 'custom-costs-item')} data-block>
      <TotalCostInfo
        type={type}
        guestCount={guestCount}
        accommodationType={accommodationType}
        determined={determined}
        currency={currency}
        costsCurrency={costsCurrency}
        value={value}
        topTextEnabled={topTextEnabled}
      />

      {roomingConfigurationEnabled && (
        <div className={'custom-costs-item-rooming'} data-block>
          <Wysiwyg type="primary" data={roomingConfigurationWysiwyg?.data} placeholder={''} isReadOnly={true} />
        </div>
      )}
    </div>
  );
}

export function CostsItem({ title, desc }: { title: string; desc: WysiwygData }) {
  return (
    <div className={cx(s.item, 'custom-costs-item')} data-block>
      <div className={cx(s.title, 'custom-costs-item-title')}>{title}</div>
      <div className={cx(s.desc, 'custom-costs-item-desc')}>
        <Wysiwyg type="primary" data={desc} placeholder={' '} isReadOnly={true} />
      </div>
    </div>
  );
}

export function TotalCostInfo({
  topTextEnabled,
  type,
  guestCount,
  accommodationType,
  determined,
  costsCurrency,
  currency,
  value,
}: TTotalCostInfoProps) {
  return (
    <>
      {topTextEnabled &&
        (!determined && !value ? (
          <div />
        ) : (
          <strong className="custom-costs-total-info">
            {i18n.t('proposal_content.costs.main_text', {
              per_type: i18n.t(`proposal_content.costs.per_type.${type}`),
              accommodation_type: i18n.t(`proposal_content.costs.accommodation.types.${accommodationType}`),
              on_guests_title: i18n.t('proposal_content.costs.on_guests', { count: guestCount }),
            })}
            :{' '}
            {determined ? (
              i18n.t('proposal_content.tbd')
            ) : (
              <>
                {costsCurrency?.disambiguateSymbol || costsCurrency?.symbol || `${currency?.toUpperCase()} ` || null}
                {currencyFormat(value)}
              </>
            )}
          </strong>
        ))}
    </>
  );
}
